import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

// Estilos personalizados para el botón
const CoolButtonRoot = styled(Button)(({ theme, ownerState }) => {
  const { color, circular, iconOnly } = ownerState;

  if (color === 'blueWhite') {
    return {
      borderRadius: circular ? '50px' : '12px',
      padding: iconOnly ? '12px' : '10px 24px',
      textTransform: 'uppercase',
      fontWeight: 600,
      fontSize: '0.9rem',
      background: 'linear-gradient(135deg, #1A73E8 )', // Fondo dividido azul y blanco
      color: 'white', // Texto azul por defecto
      border: '2px solid #1A73E8', // Borde azul
      boxShadow: `0 8px 24px rgba(0, 0, 0, 0.1)`, // Sombra suave
      transition: 'all 0.3s ease-in-out, transform 0.3s ease-in-out',
      '&:hover': {
        transform: 'scale(1.05)', // Efecto de escala al pasar el mouse
        boxShadow: `0 12px 32px rgba(0, 0, 0, 0.2)`, // Sombra más intensa
        // Invertir el fondo en hover
        // Cambiar borde a blanco
      },
      '&:active': {
        transform: 'scale(0.98)', // Efecto de reducción al hacer click
        boxShadow: `0 4px 12px rgba(0, 0, 0, 0.2)`, // Sombra más suave al hacer clic
      },
      '&:focus': {
        outline: 'none', // Eliminar outline por defecto en el enfoque
        border: '2px solid #1565c0', // Resaltar el borde al enfocarse
      },
    };
  }
  return {
    borderRadius: circular ? '50px' : '12px',
    padding: iconOnly ? '12px' : '10px 24px',
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: '0.9rem',
    // background: `linear-gradient(135deg,, #1976d2)`,
    background: `linear-gradient(135deg,, #1565c0)`,
    color: '#fff',
    boxShadow: `0 8px 24px rgba(0, 0, 0, 0.2)`,
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: `0 12px 32px rgba(0, 0, 0, 0.25)`,
      background: `linear-gradient(135deg, #1976d2,)`,
    },
    '&:active': {
      transform: 'scale(0.98)',
      boxShadow: `0 4px 12px rgba(0, 0, 0, 0.15)`,
    },
  };
});

const CoolButton = forwardRef(
  (
    {
      color = 'primary',
      variant = 'contained',
      size = 'medium',
      circular = false,
      iconOnly = false,
      children,
      ...rest
    },
    ref
  ) => (
    <CoolButtonRoot
      {...rest}
      ref={ref}
      variant={variant}
      size={size}
      ownerState={{ color, circular, iconOnly }}
    >
      {children}
    </CoolButtonRoot>
  )
);

CoolButton.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  variant: PropTypes.oneOf(['text', 'contained', 'outlined']),
  color: PropTypes.oneOf([
    'default',
    'white',
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
    'light',
    'dark',
  ]),
  circular: PropTypes.bool,
  iconOnly: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default CoolButton;
